import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Submissionhero from './Submissionhero'
import Submit from './Submit'

const Submission = () => {
  return (
    <div>
        <Header />
        <Submissionhero />
        <Submit />
        <Footer />
    </div>
  )
}

export default Submission